<template>
    <div>
        <div class="recom-list-header">
            <div class="recom-list-img" @click.stop="gotomy(item)">
                <img :src="$baseurl+item.headImg" />
            </div>
            <div class="recom-list-wz">
                <div class="recom-list-wz-tit">{{item.nick}}</div>
                <div class="recom-list-wz-stit" v-if="item.signature">{{item.signature}}</div>
                <div class="recom-list-wz-stit" v-if="!item.signature">未设置</div>
            </div>
            <div class="recom-list-fright" v-if="!item.isOwnTopic" @click.stop="Attention(item)">
                <div v-if="!item.isAttention">关注</div>
                <div v-if="item.isAttention" :style="{'background-color':$abctheme.basecolor,'color':'#fff','border':'1px solid '+$abctheme.basecolor}">已关注</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'recommendhead',
    props:{
        item:{
            type:Object,
            default:undefined
        }
    },
    data()
    {
        return {

        }
    },
    created(){

    },
    methods:{
        gotomy(item){
            this.$router.push({path:'/communitymy',query:{id:item.memberPersonalId}});
        },
        Attention(item)
        {
            this.$emit('Attention',item);
            // if(!item.isAttention)
            // {
            //     this.$emit('Attention',item);
            // }
        }
    }

}
</script>
<style lang="scss" scoped>
 .recom-list-header{
    position: relative;
    padding-left:60px;
    padding-right: 80px;
    padding-bottom:5px;
    .recom-list-img{
        position: absolute;
        left: 0;
        img{
            width: 50px;
            height: 50px;
            border-radius: 50%;
        }
    }
    .recom-list-wz{
        min-height: 50px;
        line-height: 25px;
        margin-bottom: 5px;
        .recom-list-wz-tit{
            font-size: 15px;
            font-weight: bold;
        }
        .recom-list-wz-stit{
            color:#aaa8a9;
        }   
    }
    .recom-list-fright{
        position: absolute;
        right: 0;
        top:50%;
        bottom: 0;
        transform: translate(0,-50%);
        color:#949494;
        div{
            border: 1px solid #949494;
            width: 60px;
            display: inline-block;
            text-align: center;
            border-radius: 12px;
        }
    }
}
</style>